import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateAuthenticated, CanActivateIsAdmin, CanActivateNotAuthenticated } from './authentication.service';
import { NotFoundComponent } from './not-found/not-found.component';
import { ShellComponent } from './shell/shell.component';

const routes: Routes = [
    {
        path: 'login',
        canActivate: [CanActivateNotAuthenticated],
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    },
    {
        path: '',
        component: ShellComponent,
        canActivate: [CanActivateAuthenticated],
        children: [
            {
                path: 'materials',
                loadChildren: () => import('./material-admin/material-admin.module').then(m => m.MaterialAdminModule),
            },
            {
                path: 'admin/groups',
                loadChildren: () => import('./admin/groups/groups.module').then(m => m.AdminGroupsModule),
                canActivate: [CanActivateIsAdmin],
            },
            {
                path: 'admin/users',
                loadChildren: () => import('./admin/users/users.module').then(m => m.UsersModule),
                canActivate: [CanActivateIsAdmin],
            },
            {
                path: 'admin/materialgroups',
                loadChildren: () =>
                    import('./admin/materialgroups/materialgroups.module').then(m => m.MaterialGroupsModule),
                canActivate: [CanActivateIsAdmin],
            },
            {
                path: 'admin/propertytypes',
                loadChildren: () =>
                    import('./admin/propertytypes/propertytypes.module').then(m => m.AdminPropertyTypesModule),
                canActivate: [CanActivateIsAdmin],
            },
            {
                path: 'admin/iframe-token',
                loadChildren: () => import('./admin/iframe-token/iframe-token.module').then(m => m.IframeTokenModule),
                canActivate: [CanActivateIsAdmin],
            },
            {
                path: 'settings',
                loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
            },
            {
                path: '',
                redirectTo: 'materials',
                pathMatch: 'full',
            },
            {
                path: 'not-found',
                component: NotFoundComponent,
            },
            {
                path: '**',
                redirectTo: '/not-found',
            },
        ],
    },
    {
        path: '**',
        redirectTo: '/',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
